export interface IAllCentersGrid {
    id: number,
    alias: string,
    name: string,
    city?: string,
    state?: string,
    isRemoteDonationCenter: boolean,
    isDashLiverParticipant: boolean
}

export interface ICenterDetails {
    name: string,
    exchangeCoordinator: IAllCenterExchangeKidneyCoordinator,
    kidneyPickup: IAllCenterAddress,
    kidneyDropOff: IAllCenterAddress,
    labTubeData: IAllCenterLabTubeData,
    contactList: IAllCenterContactList[],
    addressList: IAllCenterAddress[],
    serologyTests: string[]
}

export interface IAllCenterExchangeKidneyCoordinator {
    fullName: string,
    email: string,
    address: string,
    phone: string,
    isLead: boolean
}

export interface IAllCenterAddress {
    addressType: string,
    fullAddress: string,
    centerId: number
}

export interface IAllCenterLabTubeData {
    id: number,
    name: string,
    transYellow85: string,
    transRed70: string,
    transRed100: string,
    transLavender85: string,
    transLavender40: string,
    transLavender70: string,
    transLavender100: string,
    transPink60: string,
    transPink100: string,
    transGreen100: string,
    labYellow85: string,
    labRed70: string,
    labRed100: string,
    labLavender85: string,
    labLavender40: string,
    labLavender70: string,
    labLavender100: string,
    labPink60: string,
    labPink100: string,
    labGreen100: string,
    requiresQfg: any
}

export interface IAllCenterContactList {
    title: string,
    email: string,
    phoneNumbers: string[],
    positions: {id: number, position: string}[]
}
